import { safeLocalStorage as t } from "./safeStorage/safeStorage.helper.js";
var r = "defaultLanguage", s = {
  de: "Deutsch",
  fr: "Français",
  it: "Italiano"
}, i = "de", g = () => {
  const e = typeof navigator < "u" ? navigator : void 0, o = e?.languages?.length ? e.languages : [e?.userLanguage, e?.language];
  for (const n of o) {
    if (!n) continue;
    let a = n.toLowerCase();
    if (a.indexOf("-") !== -1 && (a = a.substring(0, a.indexOf("-"))), s[a]) return a;
  }
  return "de";
}, f = () => {
  const e = t.getItem(r);
  return e || g();
}, A = (e) => {
  e === g() ? t.removeItem(r) : t.setItem(r, e);
};
export {
  i as APP_DEFAULT_LANGUAGE,
  s as AVAILABLE_LANGUAGE_NAMES,
  r as DEFAULT_LANGUAGE_STORAGE_KEY,
  f as getDefaultLanguage,
  A as setDefaultLanguage
};

//# sourceMappingURL=defaultLanguage.helper.js.map